export default "__VITE_ASSET__6NemgtM2__"